import Collection from '../../collection';
import FieldFormTemplateModule from './fields.form.template';
import Grid from '../../view/grid';

import { hashify, mapEl } from '../../utils/arrays';




export default FieldFormTemplateModule.extend( {

    template: 'module/refbooks/fields.form.types',

    url() {
        return this.model.id
            ? `fields/${this.model.id}/edit/bound-types`
            : `fields/new/bound-types`;
    },

    finalizeOpen(field) {
        const {
            typesPage = 1, typesLimit = 10,
            typesSort = 'name', typesDirection = 'asc',
            typesSearch = '',
            rolesPage = 1, rolesLimit = 10,
            rolesSort = 'name', rolesDirection = 'asc',
        } = this.state() || {};

        this.setState( { 
            typesPage, typesLimit, typesSort, typesDirection, typesSearch,
            rolesPage, rolesLimit, rolesSort, rolesDirection,
        } );

        this.options.rolesSorted = new Collection();
        this.options.rolesFiltered = new Collection();
        this.options.rolesResulted = new Collection();

        return this.reSortGrid().then( () => this.reSortRolesGrid() )
            .then( () => {
                // hack to allow reFilterGrid work
                // TODO remove this hack
                this.model = field;
                this.reFilterGrid();
                // TODO
                this.reFilterRolesGrid();
                this.model = undefined;
            } )
            .then( () => this.bind( field ) );
    },

    finalizeStart(field) {
        this.listenTo( field, 'change:cluster', () => {
            this.setState( { typesPage: 1, } ), this.navigated();
            this.reFilterGrid();
        } );
        this.listenTo( field, 'change:visible', () =>
            this.Roles.render() );
    },

    // todo
    serialize() {
        const { 
            typesSort, typesDirection, typesSearch, 
            rolesSort, rolesDirection,
        } = this.state();
        const { typesFiltered, typesResulted, rolesFiltered, rolesResulted } = this.options;

        return {
            typesSearch, 
            typesSort, typesDirection, rolesSort, rolesDirection,

            current: () =>
                typesResulted.current(),

            currentRule: () =>
                currentRule( this.model, typesResulted.current() ),

            currentVisibleRoles: () =>
                findVisibleRoles.call( this, this.model, typesResulted.current() ),

            currentEnabledRoles: () =>
                this.getAvailableFilteredModelIds( rolesFiltered ),

            visibleByDefaultToggled: () => {
                const rule = currentRule( this.model, typesResulted.current() );
                return rule && [true, 't'].includes( rule.visible_by_default )
            },

            hasDiff: () => this.hasDiff(),

            types: typesFiltered, rows: typesResulted,

            checkedTypes: () => this.model.get( 'bindings' )
                .filter( binding => [undefined, true, 't'].includes( binding.on ) )
                .map( binding => binding.type.id ),

            clusters: this.options.clusters,
            roles: rolesFiltered, rolesRows: rolesResulted,
        };
    },

    events: {

        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;
            if ( this.$( currentTarget ).closest( '[name="Grid"]' ).length)
                this.setState( { typesPage: 1, typesSort: sort, typesDirection: direction, } );
            else
                this.setState( { rolesPage: 1, rolesSort: sort, rolesDirection: direction, } );

            const rendering = this.$( currentTarget ).closest( '[name="Grid"]' ).length
                ? this.reSortGrid().then( () => this.reFilterGrid() )
                : this.reSortRolesGrid().then( () => this.reFilterRolesGrid() );

            return rendering
                    // hack: to rerender grid caption with order direction
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

        'click .-toggle-binding'({currentTarget}) {
            const { id } = currentTarget.dataset;

            const on = currentTarget.checked;
            const oldBindings = this.model.get( 'bindings' );
            const newBindings = toggleBinding( id, oldBindings, on );

            this.model.set( 'bindings', newBindings );

            const checkedTypeIds = hashify( newBindings
                .filter( binding => [undefined, true, 't'].includes( binding.on ) )
                .map( binding => binding.type.id ) );
            this.$( '.-toggle-all' )[0].checked = 
                this.getAvailableFilteredModelIds( this.options.typesFiltered ).every( typeId => checkedTypeIds[typeId] );

            this.Roles.render();
        },

        'click .-toggle-all'({currentTarget}) {
            const on = currentTarget.checked;
            const oldBindings = this.model.get( 'bindings');
            const newBindings = this.getAvailableFilteredModelIds( this.options.typesFiltered )
                .reduce( 
                    (oldBindings, id) => toggleBinding( id, oldBindings, on ),
                    oldBindings );

            this.model.set( 'bindings', newBindings );

            this.$( '.-toggle-binding:not([disabled])' ).toArray()
                .forEach( el => el.checked = on );

            this.Roles.render();
        },

        'click .-toggle-role'({currentTarget}) {
            const { id } = currentTarget.dataset;

            const checked = currentTarget.checked;

            const oldBindings = this.model.get( 'bindings' );
            const newBindings = toggleRole( id, this.options.typesResulted.current(),
                oldBindings, checked );

            this.model.set( 'bindings', newBindings );

            const checkedRoleIds = hashify( findVisibleRoles.call( 
                this,
                this.model,
                this.options.typesResulted.current() ) );
            this.$( '.-toggle-all-roles' )[0].checked = 
                this.getAvailableFilteredModelIds( this.options.rolesFiltered ).every( roleId => checkedRoleIds[roleId] );
        },

        'click .-toggle-all-roles'({currentTarget}) {
            const checked = currentTarget.checked;
            const type = this.options.typesResulted.current();
            const oldBindings = this.model.get( 'bindings');
            const visibleRoleIds = hashify( findVisibleRoles.call( 
                this,
                this.model,
                this.options.typesResulted.current() ) );
            const newBindings = this.getAvailableFilteredModelIds( this.options.rolesFiltered )
                .filter( id => checked && !visibleRoleIds[id] || !checked && visibleRoleIds[id] )
                .reduce( 
                    (oldBindings, id) => toggleRole( id, type, oldBindings, checked ),
                    oldBindings );

            this.model.set( 'bindings', newBindings );

            this.$( '.-toggle-role:not([disabled])' ).toArray()
                .forEach( el => el.checked = checked );
        },

    },

    reSortGrid() {
        const { typesSort: sort, typesDirection: direction } = this.state();
        const { types, typesSorted, } = this.options;

        return Grid.sort( { sort, direction }, types, typesSorted );
    },

    reFilterGrid() {
        const { 
            typesPage: page, typesLimit: limit, typesSearch: search,
            typesActiveId: activeId, } = this.state();
        const { typesSorted, typesFiltered, typesResulted } = this.options;

        Grid.filter( { page, limit, search, activeId, }, 
            this.model.get( 'cluster' ),
            typesSorted, typesFiltered, typesResulted );
    },
    
    reSortRolesGrid() {
        const { rolesSort: sort, rolesDirection: direction } = this.state();
        const { roles, rolesSorted, } = this.options;

        return Grid.sort( { sort, direction, }, roles, rolesSorted )
    },

    reFilterRolesGrid() {
        const { rolesPage: page, rolesLimit: limit, } = this.state();
        const { typesResulted } = this.options;
        const { rolesSorted, rolesFiltered, rolesResulted } = this.options;

        Grid.filter( { page, limit }, 
            this.model.get( 'cluster' ) || typesResulted.current() && typesResulted.current().get( 'cluster' ),
            rolesSorted, rolesFiltered, rolesResulted );
    },
    
    [FieldFormTemplateModule.event( 'TypesPaging:page')](page) {
        return this.setState( { typesPage: +page, } ),
            this.reFilterGrid(),
            this.navigated();
    },

    [FieldFormTemplateModule.event( 'RolesPaging:page')](page) {
        return this.setState( { rolesPage: +page, } ),
            this.reFilterRolesGrid(),
            this.navigated();
    },

    [FieldFormTemplateModule.event( 'TypesSearch:search')](search) {
        return this.setState( { typesSearch: search, typesPage: 1, } ), 
            this.reFilterGrid(),
            this.navigated();
    },

    // TypeGrid == form, Grid == grid inside form
    [FieldFormTemplateModule.event( 'Grid:activate' )](index, type) {
        this.setState( { 
            rolesPage: 1, typesActiveId: type.id,
        } );
        this.reFilterRolesGrid();
        this.Roles.render();
        this.navigated();
    },

    [FieldFormTemplateModule.event( 'Grid:deactivate' )]() {
        this.setState( { 
            typesActiveId: undefined,
        } );
        this.Roles.render();
        this.navigated();
    },

    [FieldFormTemplateModule.event( 'Roles:visible-by-default:toggle' )]() {
        const newBindings = toggleVisibleByDefault.call( 
            this,
            this.options.typesResulted.current(),
            this.model.get( 'bindings' ) );

        this.model.set( 'bindings', newBindings );

        this.Roles.render();
    },

} );





function toggleBinding(id, oldBindings, on) {
    const containsBinding = oldBindings.find( binding => binding.type.id == id );
    if (on && !containsBinding)
        return [ 
            ...oldBindings, 
            { on: true, type: { id }, rules: [{ visible_by_default: true, visible_inverted_for_roles: [] }] }
        ];
    
    return oldBindings.map( binding => binding.type.id != id 
        ? binding
        : ({ ...binding, on }) );
}

function toggleRole(id, type, bindings, checked) {
    return mapEl( bindings,
        oldBinding => oldBinding.type.id == type.id,
        () => ({ on: false, type: { id: type.id } }),
        oldBinding => {
            const newRules = mapEl( 
                oldBinding.rules,
                () => true,
                () => ({ visible_by_default: true, visible_inverted_for_roles: [] }),
                ({ visible_inverted_for_roles, ...oldRule }) => {
                    visible_inverted_for_roles = visible_inverted_for_roles || [];
                    const needAppend = 
                        checked && [false, 'f'].includes( oldRule.visible_by_default ) || 
                        !checked && [true, 't'].includes( oldRule.visible_by_default );
                    const newInvertedForRoles = needAppend
                        ? [...visible_inverted_for_roles, +id]
                        : visible_inverted_for_roles.filter( roleId => roleId != id );
    
                    // rule удаляется, если оно новое, и ролей нет и checkbox будет включен
                    // (т.е. производится откат к состоянию до начала изменений)
                    if (oldRule.id || [false, 'f'].includes( oldRule.visible_by_default ) || newInvertedForRoles.length)
                        return { ...oldRule, visible_inverted_for_roles: newInvertedForRoles };
                } );
    
            // binding удаляется, если он новый, выключенный и правил больше нет
            // (т.е. производится откат к состоянию до начала изменений)
            if (oldBinding.id || newRules.length || oldBinding.on)
                return { ...oldBinding, rules: newRules };
        } );
}

function toggleVisibleByDefault(type, bindings) {
    const { rolesPage: page, rolesLimit: limit, } = this.state();
    const { typesResulted } = this.options;
    const roleIds = Grid.filter( { page, limit }, 
        this.model.get( 'cluster' ) || typesResulted.current() && typesResulted.current().get( 'cluster' ),
        this.options.rolesSorted )
        .filtered.toJSON()
        .map( role => +role.id );

    return mapEl( bindings,
        oldBinding => oldBinding.type.id == type.id,
        () => ({ type: { id: type.id } }),
        oldBinding => {
            const newRules = mapEl( 
                oldBinding.rules,
                () => true,
                () => ({ visible_by_default: true, visible_inverted_for_roles: [] }),
                ({ visible_by_default, visible_inverted_for_roles: roles, ...oldRule }) => {
                    visible_by_default = [true, 't'].includes( visible_by_default );
                    roles = roles || [];

                    visible_by_default = !visible_by_default;
                    roles = roleIds.filter( id => !roles.includes( id ) && !roles.includes( '' + id ) );
                    // rule удаляется, если оно новое, и ролей нет и checkbox будет выключен
                    // (т.е. производится откат к состоянию до начала изменений)
                    if (oldRule.id || !visible_by_default || roles.length)
                        return { 
                            ...oldRule, 
                            visible_by_default,
                            visible_inverted_for_roles: roles 
                        };
                } );
    
            // binding удаляется, если он новый, выключенный и правил больше нет
            // (т.е. производится откат к состоянию до начала изменений)
            if (oldBinding.id || newRules.length || oldBinding.on)
                return { ...oldBinding, rules: newRules };
        } );
}

function currentRule(model, type) {
    if (!type)
        return null;

    const [binding] = model.get( 'bindings' )
        .filter( binding => binding.type.id == type.id );

    if (!binding)
        if ([true, 't'].includes( model.get( 'is_for_all') ))
            return binding || { visible_by_default: true, visible_inverted_for_roles: [] };
        else
            return null;

    if (binding && ![undefined, true, 't'].includes( binding.on ))
        if (![true, 't'].includes( model.get( 'is_for_all') ))
            return null;

    if (!binding.rules || !binding.rules.length)
        return { visible_by_default: true, visible_inverted_for_roles: [] };

    return binding.rules[0];
}

function findVisibleRoles(model, type) {
    const rule = currentRule( model, type );
    if (!rule)
        return [];

    const { visible_by_default, visible_inverted_for_roles: roles } = rule;
    return [false, 'f'].includes( visible_by_default )
        ? roles
        : this.options.roles.toJSON()
            .map( role => +role.id )
            .filter( id => !roles.includes( id ) && !roles.includes( '' + id ) );
}


// WEBPACK FOOTER //
// ./src/js/module/refbooks/fields.form.types.js